import { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  fetchAppointmentNote,
  updateAppointmentNote,
} from '../../../../actions/sessions';
import QuillEditor from '../../../global/QuillEditor';

function Notes({
  appointmentNote = { note: '' },
  fetchAppointmentNote: fetchAppointmentNoteAction,
  updateAppointmentNote: updateAppointmentNoteAction,
}) {
  const [text, setText] = useState('');
  const propsRef = useRef({
    updateAppointmentNoteAction,
    appointmentNote,
  });
  propsRef.current = {
    updateAppointmentNoteAction,
    appointmentNote,
  };

  const updateNote = useRef(
    _.debounce(value => {
      const {
        updateAppointmentNoteAction: updateNoteAction,
        appointmentNote: note,
      } = propsRef.current;
      updateNoteAction(note.id, {
        note: value,
      });
    }, 500),
  ).current;

  useEffect(() => {
    fetchAppointmentNoteAction(appointmentNote.id, response => {
      const noteText = response.data.note;
      setText(noteText);
    });
    // Match class componentDidMount: run once on mount only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = nextText => {
    setText(nextText);
    updateNote(nextText);
  };

  return (
    <div className="sidebar-notes-container sidebar-flex">
      <QuillEditor value={text} onChange={handleChange} />
      <p className="sidebar-changes-saved">
        Your changes are automatically saved.
      </p>
    </div>
  );
}

Notes.propTypes = {
  appointmentNote: PropTypes.object,
  fetchAppointmentNote: PropTypes.func.isRequired,
  updateAppointmentNote: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    appointmentNote: _.get(
      state,
      'appointments.appointment.appointment_notes[0]',
    ),
  };
}

export default connect(mapStateToProps, {
  fetchAppointmentNote,
  updateAppointmentNote,
})(Notes);
